import { Component, ViewChild } from '@angular/core';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Modal } from 'bootstrap';
import { ProfileService } from 'src/app/_services/profile.service';
import { ScrumService } from 'src/app/_services/scrum.service';
import { TeamsService } from 'src/app/_services/teams.service';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-storico-team-passati',
  templateUrl: './storico-team-passati.component.html',
  styleUrls: ['./storico-team-passati.component.css']
})
export class StoricoTeamPassatiComponent {
  teams: any;

  years = [
    { value: '2021', viewValue: '2021' },
    { value: '2022', viewValue: '2022' },
    { value: '2023', viewValue: '2023' },
    { value: '2024', viewValue: '2024' }
  ];
  selectedYear: any;
  current_year = new Date().getFullYear();

  showPaginator: boolean = false;

  allExpanded = false;

  expanded = false;

  expandedProjects = false;
  expandedCourses = false;

  tabProjects = true;
  tabCourses = false;

  teamsProjects: any;
  teamsCourses: any;
  startSprintNumber: number | null;
  endSprintNumber: number | null;

  /* Visualizzazione dati profilo */
  myModalAlternative: Modal;
  id: any;
  profile: any;

  /* Lottie */
  public lottieConfig: Object;
  private anim: any;

  @ViewChild(MatAccordion) accordion: MatAccordion;

  constructor(
    private teamsService: TeamsService,
    private sanitizer: DomSanitizer,
    public utilityService: UtilityService,
    private profileService: ProfileService,
    private scrumService: ScrumService
  ) {
    this.selectedYear = this.current_year;
    this.lottieConfig = {
      path: 'assets/animations/sadCat.json',
      renderer: 'canvas',
      autoplay: true,
      loop: true
    };
  }

  ngOnInit() {
    this.getTeams(this.selectedYear);
    this.utilityService.setTitle('Storico team passati');
  }

  ngAfterViewInit(): void {
    const el = document.querySelector('#profileModal');
    if (el) {
      this.myModalAlternative = new Modal(el);
    }
  }

  selectYears(event: string) {
    this.selectedYear = event;
    this.getTeams(this.selectedYear);
  }

  getTeams(year: '') {
    let utility = this.utilityService;
    year == this.selectedYear;
    this.teamsService.getTeams(year, 0, 0).subscribe(res => {
      this.teams = res.result;
      this.teamsProjects = res.result.filter(
        (item: any) => item.is_course !== 1
      );

      this.teamsProjects.forEach(function (project: any) {
        project.filestorage.path = utility.getSanitizeUrl(
          project.filestorage.path
        );

        project.project_user.forEach(function (user_pivot: any) {
          user_pivot.user.filestorage.path = utility.getSanitizeUrl(
            user_pivot.user.filestorage.path
          );
        });
      });

      this.teamsCourses = res.result.filter(
        (item: any) => item.is_course !== 0
      );

      this.teamsCourses.forEach(function (course: any) {
        course.filestorage.path = utility.getSanitizeUrl(
          course.filestorage.path
        );

        course.project_user.forEach(function (user_pivot: any) {
          user_pivot.user.filestorage.path = utility.getSanitizeUrl(
            user_pivot.user.filestorage.path
          );
        });
      });

      if (this.teams.project_user?.length > 10) this.showPaginator = true;
    });
  }

  // funzione che gestisce il cambio di tab e resetta lo stato di espansione degli accordion
  checkTab(event: any) {
    if (event.index === 0) {
      this.tabProjects = true;
      this.tabCourses = false;
      this.expandedProjects = false;
      this.expandedCourses = false;
    } else {
      this.tabProjects = false;
      this.tabCourses = true;
      this.expandedProjects = false;
      this.expandedCourses = false;
    }
    this.allExpanded = false;
  }

  // funzione che gestisce il cambio di stato (espanso o chiuso) per i progetti o i corsi
  change(tab: boolean) {
    if (tab === this.tabProjects && this.tabProjects) {
      this.expandedProjects = !this.expandedProjects;
      this.expandedCourses = false;
    } else {
      this.expandedProjects = false;
      this.expandedCourses = !this.expandedCourses;
    }
  }

  public getSanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getProfile(project_user: any) {
    return project_user.map((profile: any) => ({
      img: profile?.user?.filestorage?.path,
      fullname: profile?.user?.first_name + ' ' + profile?.user?.last_name,
      roles: profile.assignmentroles.map((item: any) => item)
    }));
  }

  /* ANIMATION GIF */
  handleAnimation(anim: any) {
    this.anim = anim;
  }

  toggleFlip(card: any, projectId: any) {
    // if (!card.classList.contains('flipped')) this.getDataSprint(projectId)

    card.classList.toggle('flipped');
  }

  getElement(element: any) {
    this.id = element;
    this.myModalAlternative.show(); /* Per aprire la modale al click dell'immagine */
    this.getProfileUser();
  }

  getProfileUser() {
    this.profileService.profileUser(this.id).subscribe(res => {
      this.profile = res.result;
    });
  }

  setDate(
    project_id: number,
    number: number,
    toggle: boolean,
    other_number: any
  ) {
    /* DA AGGIORNARE NON APPENA RORY AGGIUNGE I CAMPI DI START_SPRINT E END_SPRINT NELLA GET TEAMS */
    if (toggle) {
      if (
        !this.endSprintNumber ||
        (this.endSprintNumber && this.endSprintNumber >= number)
      )
        this.startSprintNumber = number;
      this.endSprintNumber = other_number;
    } else {
      if (
        !this.startSprintNumber ||
        (this.startSprintNumber && this.startSprintNumber <= number)
      )
        this.endSprintNumber = number;
      this.startSprintNumber = other_number;
    }

    if (this.startSprintNumber && this.endSprintNumber)
      /*  this.getTeams(); */
      this.scrumService
        .getDataSprint(project_id, this.startSprintNumber, this.endSprintNumber)
        .subscribe(res => {
          /*         this.startDateGraph = this.dataSprint.start_date;
        this.endDateGraph = this.dataSprint.end_date; */

          /* Aggiornamento dati statistici del progetto selezionato */
          this.teamsProjects.find(
            (project: any) => project.id == project_id
          ).statistical = res;
        });
  }
}
